const NODES = [
  {
    label: "WEEK 1–2",
    title: "Frame",
    body: "First 1-on-1 with Alex. Frame audit. Set up your sales identity. Drop into the network. First AI roleplay reps.",
  },
  {
    label: "WEEK 3–5",
    title: "Reps",
    body: "Full framework library unlocked. Daily AI drills. Second 1-on-1. By the end your objection handling starts running on instinct, not memory.",
  },
  {
    label: "WEEK 6–9",
    title: "Live",
    body: "Third 1-on-1. You move from drills to live reps inside the network. First real call pressure. Frame audits on your actual recordings.",
  },
  {
    label: "WEEK 10–13",
    title: "Closer-ready",
    body: "Final 1-on-1. Frame locked. Reps in. Recordings to show. You're no longer studying sales. You can hold a real call.",
  },
  {
    label: "THE HORIZON",
    title: "Placement",
    body: "From here we start putting you in front of real offers. Passing the bar is on you, and it's rarely instant. Most operators get there in the months after. We keep the door open and keep working with you until you're in.",
  },
];

export default function Path90() {
  return (
    <section className="access-section">
      <div className="access-container">
        <div className="max-w-3xl">
          <span className="mono-label mono-label-gold">THE FIRST 90 DAYS</span>
          <h2 className="h-section mt-5">The first 90 days build the closer. The offer comes after.</h2>
        </div>

        <ol className="mt-14 relative max-w-3xl">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-gold/60 via-gold/30 to-transparent" aria-hidden />
          {NODES.map((n, i) => (
            <li key={n.label} className="relative pl-10 pb-12 last:pb-0">
              <span
                className="absolute left-0 top-1.5 w-[15px] h-[15px] rounded-full bg-gold"
                style={{ boxShadow: "0 0 0 4px var(--bg-primary), 0 0 24px rgba(201,169,110,0.5)" }}
              />
              <div className="flex items-baseline gap-3">
                <span className="mono-label mono-label-gold">{n.label}</span>
                <span className="mono-label">· STEP {String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="h-card mt-3 text-bone">{n.title}</h3>
              <p className="mt-3 text-dim body-lg max-w-2xl">{n.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
